export class Tag {
  id: number;
  title: string;
  groupId: number;
  createdAt: string;
  updatedAt: string;
  constructor() {
    this.id = null;
    this.title = '';
    this.groupId = null;
    this.createdAt = '';
    this.updatedAt = '';
  }
}
